// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { timeseriesSeriesId } from './TimeseriesSeries';
import { z } from 'zod';
export const timeseriesPoint = z.object({
    series_id: timeseriesSeriesId,
    ts: z.date(),
    value: z.number(),
});
export const timeseriesPointInitializer = z.object({
    series_id: timeseriesSeriesId,
    ts: z.date(),
    value: z.number(),
});
export const timeseriesPointMutator = z.object({
    series_id: timeseriesSeriesId.optional(),
    ts: z.date().optional(),
    value: z.number().optional(),
});
//# sourceMappingURL=TimeseriesPoint.js.map